import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { PerfOverlay } from "@/components/PerfOverlay";
import { SessionProvider } from "@/features/auth/SessionProvider";
import { queryClient } from "@/lib/queryClient";
import { bootstrapPerf } from "@/lib/perf";
import { installQueryPerfTracking } from "@/lib/queryPerf";
import { applyBrand, applyIdentity } from "@/lib/brand";
import { appConfig, brandIdentity } from "@/config/app";
import App from "./App.tsx";
import "./index.css";

// Traçage de performance : n'a lieu QUE si `?debug=perf` (ou le flag persisté)
// est présent. Éteint, `bootstrapPerf` ne pose aucun observer, n'écrit rien et
// on n'abonne pas le cache de requêtes — coût nul en production.
// Avant le premier rendu, pour ne manquer aucune requête du chargement initial.
if (bootstrapPerf()) {
  installQueryPerfTracking(queryClient);
}

// White-label : avant le premier rendu, pour éviter un flash aux couleurs par défaut.
applyBrand(
  document.documentElement,
  appConfig.primaryColor,
  appConfig.accentColor,
);
applyIdentity(document, {
  name: appConfig.name,
  logoUrl: brandIdentity.logoUrl,
  customName: brandIdentity.customName,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        {/* Navigations en transition : la page affichée reste pendant que la
            suivante se télécharge (voir RouteLoadingOverlay). */}
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <App />
          <Toaster richColors position="top-right" />
          {/* Se rend à `null` tant que le traçage est éteint. */}
          <PerfOverlay />
        </BrowserRouter>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
